import { Schema } from 'prosemirror-model';

import { TFunction } from '@lyearn/i18n';

import { createReactNodeView } from '../ReactNodeView';
import { IReactNodeViewPortalsContext } from '../ReactNodeViewPortals';

export enum extensionType {
  mark = 'mark',
  node = 'node',
  toolbar = 'toolbar',
}

export enum PerformanceType {
  SCROLL_BASED = 'scroll_based',
  BLOCK_BASED = 'block_based',
}

export interface EditorOptions {
  schema: Schema;
  createReactNodeView: createReactNodeView;
  portalApi: IReactNodeViewPortalsContext;
  t: TFunction;
  isLocalizedContent: boolean;
  isMicroLearning: boolean;
  isByteContent?: boolean;
}
